import "./scss/app.scss";
import picGrainne from "./images/picGrainne.jpg";

const banner = () => {
  document.getElementById(
    "middleDiv"
  ).innerHTML = `<img class="expertPicStyle" src="${picGrainne}"/>`;

  document.getElementById(
    "topDiv"
  ).innerHTML = `<p class="subHeadlineStyle">View from our property expert</p>`;

  document.getElementById("bottomDiv").innerHTML = `
  <p class="expertNameStyle">Gráinne Gilmore</p>
  <p class="expertDescriptionStyle">Head of research</p>`;
};

banner();
